import { useEffect, useState } from "react";
import { useIsCamdeed } from "./useIsCamdeed";

const camdeedLogoUrl = process.env.PUBLIC_URL + "/camdeed-logo-v2-white.png";
const camdeedSlideshowLogoUrl = process.env.PUBLIC_URL + "/camdeed-stroke.png";
const tuokisLogoUrl = process.env.PUBLIC_URL + "/tuokis-logo.png";
const tuokisSlideshowLogoUrl = process.env.PUBLIC_URL + "/tuokis-logo.png";

export const useBranding = () => {
  const [logoUrl, setLogoUrl] = useState("");
  const [slideshowLogoUrl, setSlideshowLogoUrl] = useState("");
  const isCamdeed = useIsCamdeed();

  useEffect(() => {
    const logoUrl = isCamdeed ? camdeedLogoUrl : tuokisLogoUrl;
    setLogoUrl(logoUrl);
  }, [isCamdeed]);

  useEffect(() => {
    const slideshowLogoUrl = isCamdeed ? camdeedSlideshowLogoUrl : tuokisSlideshowLogoUrl;
    setSlideshowLogoUrl(slideshowLogoUrl);
  }, [isCamdeed]);

  const brand = isCamdeed ? "camdeed" : "tuokis";
  const brandName = isCamdeed ? "Camdeed" : "Tuokis";
  const homepage = isCamdeed ? "https://camdeed.com" : "https://tuokis.com";
  const emailDomain = isCamdeed ? "camdeed.com" : "tuokis.com";
  const appDomain = isCamdeed ? "camdeed.app" : "tuokis.app";
  const instaUrl = isCamdeed ? "https://instagram.com/camdeedapp" : "https://instagram.com/tuokisapp";
  const instaHandle = isCamdeed ? "@camdeedapp" : "@tuokisapp";

  return { logoUrl, slideshowLogoUrl, brand, brandName, homepage, emailDomain, appDomain, instaUrl, instaHandle };
};
